module.exports = __webpack_public_path__ + "media/images/sabine-bdf417bdb02703681442bfec083f56ae.jpg";